import PropTypes from 'prop-types';

export default PropTypes.shape({
  hash: PropTypes.string.isRequired,
  verListApps: PropTypes.string, // TODO(clairbee): define the semver's shape
});
